import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { GlobalStateContext } from "../GlobalStates";
import { getImpersonatedAsName, getImpersonatorName, isImpersonating, restoreSuperuserSession } from "../../helperData/orgImpersonation";

const ImpersonationBanner = () => {
    const { auth, setAuth } = useContext(GlobalStateContext);
    const { t } = useTranslation();
    const navigate = useNavigate();

    if (!isImpersonating()) return null;

    const returnToSuperuser = () => {
        const ok = restoreSuperuserSession();
        if (!ok) return;
        setAuth({
            ...auth,
            access_token: window.sessionStorage.auth || "",
            username: window.sessionStorage.username || "",
            id: Number(window.sessionStorage.id) || "",
            usertype: Number(window.sessionStorage.usertype) || "",
            usercompany: window.sessionStorage.usercompany || "",
            first_name: window.sessionStorage.first_name || "",
            last_name: window.sessionStorage.last_name || "",
            package: window.sessionStorage.package
                ? JSON.parse(window.sessionStorage.package)
                : {},
            sidebar_config: window.sessionStorage.sidebar_config
                ? JSON.parse(window.sessionStorage.sidebar_config)
                : {},
            company_admin: window.sessionStorage.company_admin
                ? JSON.parse(window.sessionStorage.company_admin)
                : false,
            is_superuser: window.sessionStorage.is_superuser
                ? JSON.parse(window.sessionStorage.is_superuser)
                : false,
            email: window.sessionStorage.email || "",
        });
        document.body.classList.remove("no_overflow");
        navigate("/dashboard");
    };

    const by = getImpersonatorName();
    const asName = getImpersonatedAsName();

    return (
        <div className="impersonation_banner">
            <div>
                {asName
                    ? t("OrgManagement.Impersonating.UserBanner", { name: asName })
                    : t("OrgManagement.Impersonating.Banner")}
            </div>
            {by && <div className="impersonation_banner_by">{by}</div>}
            <button
                type="button"
                className="impersonation_banner_return"
                onClick={returnToSuperuser}
            >
                {t("OrgManagement.Return.Superuser")}
            </button>
        </div>
    );
};

export default ImpersonationBanner;
